"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } } function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* eslint-disable @typescript-eslint/no-explicit-any */

var _react = require('@sentry/react'); var Sentry = _interopRequireWildcard(_react);


var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _authorization = require('shared/services/authorization');

var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);
var _posthog = require('web/services/posthog'); var _posthog2 = _interopRequireDefault(_posthog);
var _signupAttribution = require('web/services/signupAttribution');
var _downloadModalFlag = require('web/screens/onboardingShared/downloadModalFlag');
var _onboardingAnalytics = require('web/services/onboardingAnalytics');

 const telemetryMiddleware = () => () => next => (action) => {
  if (_actionCreators2.default.loadPatientConversationByCodeActions.SUCCESS.match(action)) {
    const { Patients: patients } = action.payload
    const [patient] = Object.values(patients || {})
    if (patient) _amplitude2.default.setUserId(patient.PatientKey)
    if (patient) _posthog2.default.identify(patient.PatientKey)
    return next(action)
  }

  if (_actionCreators2.default.loginSuccessAction.match(action)) {
    const { User: user, Orgs: orgs } = action.payload
    _amplitude2.default.setUserId(user.UserKey)
    const signupDistinctId = _signupAttribution.getSignupPostHogDistinctId.call(void 0, )
    // Per-signup id — fresh each signup, safe to merge unconditionally. The
    // DEVICE-scoped public-site id is deliberately NOT aliased here (or
    // anywhere client-side): it is shared by every user of the browser, and
    // aliasing it per login chained all of a device's users into one PostHog
    // person. The backend merges it once, safely, via $identify-with-anon at
    // signup completion (welcome_server).
    if (signupDistinctId && signupDistinctId !== user.UserKey) _posthog2.default.alias(user.UserKey, signupDistinctId)

    const userOrgNames = []
    let isBloom = false
    const orgKeys = Object.keys(user.Relationships || {}) 
    orgKeys.forEach(k => {
      const orgName = _optionalChain([orgs, 'access', _ => _[k], 'optionalAccess', _2 => _2.Name]) || ''
      userOrgNames.push(orgName)
      isBloom = isBloom || !!_authorization.superUserOrgKeys[k]
    })

    const primaryOrg = orgKeys[0] ? orgs[orgKeys[0]] : null
    _posthog2.default.identify(user.UserKey, {
      email: user.Email,
      org_count: orgKeys.length,
      primary_org_member_count: _optionalChain([primaryOrg, 'optionalAccess', _3 => _3.NumberOfMembers]),
      primary_org_features: _optionalChain([primaryOrg, 'optionalAccess', _4 => _4.EnabledFeatures]),
    })

    orgKeys.forEach(k => {
      const org = orgs[k]
      if (!org) return
      _posthog2.default.group('organization', k, {
        member_count: org.NumberOfMembers,
        features: org.EnabledFeatures,
        created_at: org.CreatedAt,
      })
    })
    _onboardingAnalytics.captureWebAppOpenedAfterSignup.call(void 0, user)

    _amplitude2.default.setOrgNames(userOrgNames, isBloom)
    return next(action)
  }

  if (_actionCreators2.default.logoutAction.match(action)) {
    // The stored signup attribution must not outlive the session: its
    // per-signup signup_distinct_id would otherwise be aliased (line 33) to
    // whoever logs in next on this browser, merging them into the previous
    // signup's PostHog person. Every route to a different user's login passes
    // through a logout (the Login screen dispatches one on mount), so clearing
    // here closes the shared-machine merge without touching the attribution
    // properties the active onboarding session still captures.
    _signupAttribution.clearSignupAttribution.call(void 0, )
    // Same shared-tab hygiene for the onboarding session markers: left in
    // place they suppress the NEXT first-time user's welcome/SMS prompts.
    _downloadModalFlag.clearOnboardingBreadcrumbs.call(void 0, )
    _posthog2.default.reset()
  }

  if (
    action.type.startsWith('SUCCESS ')
      || action.type.startsWith('FAILURE ')
  ) {
    _amplitude2.default.logEvent(action.type)
  }

  Sentry.addBreadcrumb({
    category: 'action',
    message: action.type,
    level: 'info',
  })

  return next(action)
}; exports.telemetryMiddleware = telemetryMiddleware
